import { defineMessages } from 'react-intl';

export const featureMessages = defineMessages({
  demoOrdersTitle: {
    description: 'Title for demo orders labs feature',
    defaultMessage: 'Demo Orders',
    id: 'uLVKP7',
  },
  demoOrdersDescription: {
    description: 'Description for demo orders labs feature',
    defaultMessage: 'Explore ShipStation features with a sample demo order without affecting your real orders.',
    id: '0Uu74w',
  },
  demoOrdersConfirmationText: {
    description: 'Confirmation text explaining what happens when demo orders is enabled',
    defaultMessage:
      "We'll create a demo order with sample products in a demo store. You can explore shipping workflows, label configuration, and order management features safely. The demo order and store can be deactivated at any time.",
    id: 'pyCGcD',
  },
  aiAutomationRuleCreatorTitle: {
    description: 'AI Automation Rule Creator feature title',
    defaultMessage: 'AI Automation Rule Creator',
    id: 'mac+QH',
  },
  aiAutomationRuleCreatorDescription: {
    description: 'AI Automation Rule Creator feature description',
    defaultMessage: 'Create automation rules using natural language powered by AI.',
    id: 'Io4UKf',
  },
  aiAutomationRuleCreatorConfirmationText: {
    description: 'AI Automation Rule Creator feature confirmation text',
    defaultMessage:
      "The AI-Powered Automation Rule Creator allows you to use natural language to make new automation rules .{br}{br}💡 How It Works: {br}• Once enabled, a new prompt box will appear on the automation rule creation page.{br}• Type in plain English descriptions of the automation rule you want to create.{br}• Example: Create a rule that tags all Amazon orders with tag Prime.{br}• Once you click Submit, you'll have a chance to review the generated rule before it's created.{br}{br}⚠️ Caveats:{br}• This feature is powered by AI and may not always generate perfect rules. Please review the generated rule carefully before saving.{br}• To use this feature, you must have the appropriate permissions to create automation rules in your account.",
    id: 'axhazP',
  },
  PickListsCustomizedTitle: {
    description: 'Pick Lists Customized feature title',
    defaultMessage: 'Customizable Pick Lists',
    id: 'by9o7z',
  },
  PickListsCustomizedDescription: {
    description: 'Pick Lists Customized feature description',
    defaultMessage:
      'Create and manage customizable pick lists for your products.{br}If you’d like to use the new template for all automatically generated Pick Lists, please let us know.',
    id: 'Fpj9xC',
  },
  PickListsCustomizedConfirmationText: {
    description: 'Pick Lists Customized feature confirmation text',
    defaultMessage:
      'This is an early access preview of Pick Lists Customized functionality. You can create and manage pick lists to better organize your products.{br}{br}✅ What This Does:{br}• Create and manage pick lists{br}• Organize products by specific criteria{br}• Improve picking efficiency and accuracy{br}• Streamline order fulfillment processes',
    id: 'fsFnE1',
  },
  aiHarmonizationCodeGeneratorTitle: {
    description: 'AiHarmonizationCodeGenerator feature title',
    defaultMessage: 'AI Harmonization Code Generator',
    id: 'lXARD7',
  },
  aiHarmonizationCodeGeneratorDescription: {
    description: 'AiHarmonizationCodeGenerator feature description',
    defaultMessage: 'Generate harmonization codes for your products using AI-powered analysis of product descriptions.',
    id: 'vAeJ3x',
  },
  aiHarmonizationCodeGeneratorConfirmationText: {
    description: 'AiHarmonizationCodeGenerator feature confirmation text',
    defaultMessage:
      'This is an early access preview of AI-powered Harmonization Code generation. Get intelligent suggestions for HS codes based on your product descriptions to create more accurate customs forms.{br}{br}✅ What This Does:{br}• Analyzes product descriptions to suggest appropriate 6 digit international harmonization codes{br}• Helps ensure customs compliance for international shipments{br}• Reduces manual lookup time for HS code classification{br}• Improves accuracy of customs declarations{br}{br}🚀 Key Benefits:{br}• Faster international shipping processing{br}• Reduced risk of customs delays{br}• AI-powered suggestions based on product details',
    id: 'F20yXc',
  },
  aiShippyAssistantTitle: {
    description: 'Ask ShipStation feature title',
    defaultMessage: 'Ask ShipStation',
    id: 'dk6W3M',
  },
  aiShippyAssistantDescription: {
    description: 'AI Shippy Assistant feature description',
    defaultMessage: 'Your AI-powered guide to help you navigate ShipStation and find the pages and settings you need.',
    id: 'VSLvDP',
  },
  aiShippyAssistantConfirmationText: {
    description: 'AI Shippy Assistant feature confirmation text',
    defaultMessage:
      'Your AI-powered navigation guide to help you quickly find pages, settings, and features in ShipStation.{br}{br}✅ What This Does:{br}• Answers "where do I find..." questions{br}• Guides you to the right page for any task{br}• Helps you discover features you didn\'t know existed{br}{br}🚀 Key Benefits:{br}• Save time navigating the app{br}• Get to the right place without searching through menus',
    id: 'I05IJo',
  },
  demoOrdersCtaButtonTitle: {
    description: 'CTA button title for demo orders feature',
    defaultMessage: 'Launch Demo Orders',
    id: '8TxVs3',
  },
  aiAutomationRuleCreatorCtaButtonTitle: {
    description: 'CTA button title for AI automation rule creator feature',
    defaultMessage: 'Launch AI Automation Rule Creator',
    id: 'a1/sgn',
  },
  lotTrackingCtaButtonTitle: {
    description: 'CTA button title for lot tracking feature',
    defaultMessage: 'Launch Lot Tracking',
    id: 'yy3d7e',
  },
  pickListsCustomizedCtaButtonTitle: {
    description: 'CTA button title for customizable pick lists feature',
    defaultMessage: 'Launch Pick List Editor',
    id: 'MR7Znk',
  },
  aiHarmonizationCodeGeneratorCtaButtonTitle: {
    description: 'CTA button title for AI harmonization code generator feature',
    defaultMessage: 'Launch AI Harmonization Code Generator',
    id: 'GUpWlB',
  },
  aiShippyAssistantCtaButtonTitle: {
    description: 'CTA button title for AI Shippy Assistant feature',
    defaultMessage: 'Launch AI Assistant',
    id: 'OPSAaG',
  },
  conversationalAnalyticsTitle: {
    description: 'Conversational Analytics feature title',
    defaultMessage: 'Conversational Analytics',
    id: 'k+j7oT',
  },
  conversationalAnalyticsDescription: {
    description: 'Conversational Analytics feature description',
    defaultMessage: 'Ask questions about your shipping data in natural language and get instant AI-powered answers.',
    id: 'FkKQSr',
  },
  conversationalAnalyticsConfirmationText: {
    description: 'Conversational Analytics feature confirmation text',
    defaultMessage:
      'Enable Conversational Analytics to explore your shipping data using natural language questions.{br}{br}✅ What This Does:{br}• Ask questions about orders, shipments, and carriers in plain English{br}• Get instant AI-powered answers with charts and visualizations{br}• Explore trends and patterns without building custom reports{br}{br}🚀 Key Benefits:{br}• Faster access to shipping insights{br}• No report-building skills required{br}• Interactive follow-up questions for deeper analysis',
    id: 'EpKOj+',
  },
  conversationalAnalyticsCtaButtonTitle: {
    description: 'CTA button title for Conversational Analytics feature',
    defaultMessage: 'Launch Conversational Analytics',
    id: 'FsPnpB',
  },
  orderDetailsCustomLayoutTitle: {
    description: 'Order Details Custom Layout feature title',
    defaultMessage: 'Customizable Order Details Layout',
    id: 'RWB3RX',
  },
  orderDetailsCustomLayoutDescription: {
    description: 'Order Details Custom Layout feature description',
    defaultMessage: 'Customize the layout and sections displayed on the order details page.',
    id: 'wDsAvt',
  },
  orderDetailsCustomLayoutConfirmationText: {
    description: 'Order Details Custom Layout feature confirmation text',
    defaultMessage:
      'Customize your order details view to match your workflow.{br}{br}✅ What This Does:{br}• Drag and drop to reorder sections{br}• Choose between 1, 2, or 3 column layouts{br}• Show or hide sections based on your needs{br}{br}🚀 Key Benefits:{br}• Personalized workspace that fits your workflow{br}• Faster access to the information you use most{br}• Layout preferences are saved to your account',
    id: 'oTQe3/',
  },
  automationWorkflowsTitle: {
    description: 'Automation Workflows feature title',
    defaultMessage: 'Automation Workflows',
    id: 'qejOdh',
  },
  automationWorkflowsDescription: {
    description: 'Automation Workflows feature description',
    defaultMessage: 'Enables Automation Workflows.',
    id: 'yJqGrH',
  },
  automationWorkflowsConfirmationText: {
    description: 'Automation Workflows feature confirmation text',
    defaultMessage:
      'This is an early access preview of Automation Workflows.{br}{br}✅ What This Does:{br}• Build and manage automation workflows to streamline your shipping operations{br}• Chain multiple actions together into a single automated sequence{br}{br}🚀 Key Benefits:{br}• Save time by automating repetitive tasks{br}• Reduce manual errors with consistent workflow execution',
    id: 'FEBSvJ',
  },
  automationWorkflowsCtaButtonTitle: {
    description: 'CTA button title for Automation Workflows feature',
    defaultMessage: 'Launch Automation Workflows',
    id: 'tElJQh',
  },
  orderDetailsCustomLayoutCtaButtonTitle: {
    description: 'CTA button title for Order Details Custom Layout feature',
    defaultMessage: 'Navigate to Orders',
    id: 'leBlpL',
  },
  packingRecommendationsTitle: {
    description: 'Packing Recommendations feature title',
    defaultMessage: 'Packing Recommendations',
    id: 'HjB4UW',
  },
  packingRecommendationsDescription: {
    description: 'Packing Recommendations feature description',
    defaultMessage: 'Get suggestions for the best package to use based on your order items and available packages.',
    id: 'UCeZKF',
  },
  packingRecommendationsConfirmationText: {
    description: 'Packing Recommendations feature confirmation text',
    defaultMessage:
      'Enable packing recommendations to optimize your package selection.{br}{br}Setup Requirements:{br}• At least one custom package with dimensions and max weight configured{br}• Product dimensions and weight filled in (if not set, package dimensions and weight are used){br}{br}What This Does:{br}• Analyzes product dimensions and weights to suggest the best-fit package{br}• Supports single and multi-package recommendations{br}• Applies package, dimensions, and weight with one click{br}• Automatically shows product dimensions and custom package weight columns{br}{br}Key Benefits:{br}• Reduce shipping costs by choosing optimal package sizes{br}• Save time on manual package selection{br}• Minimize wasted space and packaging materials',
    id: 'llmi3t',
  },
  packingRecommendationsCtaButtonTitle: {
    description: 'CTA button title for Packing Recommendations feature',
    defaultMessage: 'Navigate to Orders',
    id: 'Db7IwZ',
  },
  lossPreventionTitle: {
    description: 'Loss Prevention feature title',
    defaultMessage: 'Loss Prevention',
    id: '5fokUZ',
  },
  lossPreventionDescription: {
    description: 'Loss Prevention feature description',
    defaultMessage: 'Protect your business from fraudulent orders with address blacklist management and fraud detection rules.',
    id: '1eIvlp',
  },
  lossPreventionConfirmationText: {
    description: 'Loss Prevention feature confirmation text',
    defaultMessage:
      'Enable Loss Prevention to protect your business from fraudulent orders and chargebacks.{br}{br}What This Does:{br}• Block or flag orders from blacklisted addresses{br}• Detect international address mismatches (billing ≠ shipping country){br}• Flag orders placed during unusual hours{br}• Manage address blacklist with import/export{br}{br}Key Benefits:{br}• Reduce fraud and chargebacks{br}• Protect your revenue and reputation{br}• Customizable blocking rules{br}• Easy blacklist management',
    id: 'DKi5sE',
  },
  lossPreventionCtaButtonTitle: {
    description: 'CTA button title for Loss Prevention feature',
    defaultMessage: 'Launch Loss Prevention',
    id: 'U0nAf+',
  },
});
